import {
    driverIdPairs,
    seriesIdPairs,
    mainCategoriesIdPairs,
    diecastSubCategoriesIdPairs,
    raceUsedSubCategoriesIdPairs,
    driverWornSubCategoriesIdPairs,
    sheetMetalSubCategoriesIdPairs,
    teamIssuedSubCategoriesIdPairs,
    diecastYearCategoriesIdPairs,
    diecastVersionCategoriesIdPairs,
    tradingCardYearCategoriesIdPairs,
    tradingCardBrandCategoriesIdPairs,
    tradingCardTypeCategoriesIdPairs,
    heroCardYearCategoriesIdPairs,
    programsTicketsYearCategoriesIdPairs,
} from '../constants/dropdownIdPairs';

export function getCollectiblePrefill(data) {
    const formFields = {
        driverName: data.driver || '',
        title: data.title || '',
        description: data.description || '',
        series: data.series || '',
        mainCategory: data.mainCategory || '',
        subCategory: data.subCategory || '',
        subSubCategory: data.subSubCategory || '',
        subSubSubCategory: data.subSubSubCategory || '',
    };

    const selected = {
        driver: driverIdPairs.find((d) => d.fullName === data.driver) || null,
        series: seriesIdPairs.find((s) => s.seriesName === data.series) || null,
        mainCategory: mainCategoriesIdPairs.find((m) => m.name === data.mainCategory) || null,
        diecastSubCategory: null,
        raceUsedSubCategory: null,
        sheetMetalSubCategory: null,
        driverWornSubCategory: null,
        teamIssuedSubCategory: null,
        diecastYearCategory: null,
        diecastVersionCategory: null,
        tradingCardYearCategory: null,
        tradingCardBrandCategory: null,
        tradingCardTypeCategory: null,
        heroCardYearCategory: null,
        programTicketYearCategory: null,
    };

    switch (data.mainCategory) {
        case 'Diecasts': {
            selected.diecastSubCategory = diecastSubCategoriesIdPairs.find((i) => i.name === data.subCategory) || null;
            selected.diecastYearCategory = diecastYearCategoriesIdPairs.find((i) => i.name === data.subSubCategory) || null;
            selected.diecastVersionCategory = diecastVersionCategoriesIdPairs.find((i) => i.name === data.subSubSubCategory) || null;
            break;
        }
        case 'Trading Cards': {
            selected.tradingCardYearCategory = tradingCardYearCategoriesIdPairs.find(
                (i) => i.id === String(data.subCategoryId) || i.name === data.subCategory
            ) || null;
            if (selected.tradingCardYearCategory) {
                formFields.subCategory = selected.tradingCardYearCategory.name;
            }
            selected.tradingCardBrandCategory = tradingCardBrandCategoriesIdPairs.find((i) => i.name === data.subSubCategory) || null;
            selected.tradingCardTypeCategory = tradingCardTypeCategoriesIdPairs.find((i) => i.name === data.subSubSubCategory) || null;
            break;
        }
        case 'Hero Cards / Post Cards': {
            selected.heroCardYearCategory = heroCardYearCategoriesIdPairs.find((i) => i.name === data.subCategory) || null;
            break;
        }
        case 'Programs / Tickets': {
            selected.programTicketYearCategory = programsTicketsYearCategoriesIdPairs.find((i) => i.name === data.subCategory) || null;
            break;
        }
        case 'Race Used / Team Issued': {
            selected.raceUsedSubCategory = raceUsedSubCategoriesIdPairs.find((i) => i.name === data.subCategory) || null;
            if (data.subCategory === 'Sheet Metal / Body Panel') {
                selected.sheetMetalSubCategory = sheetMetalSubCategoriesIdPairs.find((i) => i.name === data.subSubCategory) || null;
            } else if (data.subCategory === 'Driver Worn') {
                selected.driverWornSubCategory = driverWornSubCategoriesIdPairs.find((i) => i.name === data.subSubCategory) || null;
            } else if (data.subCategory === 'Team Issued') {
                selected.teamIssuedSubCategory = teamIssuedSubCategoriesIdPairs.find((i) => i.name === data.subSubCategory) || null;
            }
            break;
        }
        default:
            break;
    }

    return { formFields, selected };
}
